import React from 'react';
import SearchInputField from './SearchInputField';
import SearchResultList from './SearchResultList';
import Spinner from '../../Spinners/Spinner';
import { useRoutes } from '../../../hooks/routes/useRoutes';

/**
 * 🔍 SearchInput (versión final con API y Redux)
 *
 * - Usa `useRoutes()` para conectarse al backend.
 * - `SearchInputField` gestiona el texto y dispara búsquedas.
 * - Este componente solo muestra resultados y estados globales.
 */
const SearchInput: React.FC = () => {
  const { routes, isLoading } = useRoutes();

  return (
    <div className="relative hidden sm:inline-block">
      {/* 🧾 Campo de búsqueda con lógica interna */}
      <SearchInputField />

      {/* 🔄 Estado de carga (spinner + texto en línea) */}
      {isLoading && (
        <div
          className="animate-fadeIn absolute left-0 top-full mt-2 flex w-full items-center justify-center
                     gap-3 rounded-2xl border border-stroke bg-white px-4 py-1.5
                     shadow-md dark:border-strokedark dark:bg-boxdark"
        >
          <Spinner size={20} color="#3C50E0" />
          <span className="text-gray-600 dark:text-gray-300 select-none text-sm font-medium">
            Buscando...
          </span>
        </div>
      )}

      {/* 📋 Resultados */}
      {!isLoading && routes.length > 0 && (
        <SearchResultList results={routes} onClose={() => {}} />
      )}
    </div>
  );
};

export default SearchInput;
